// The five faces on the kiosk, worst first. The server reports every rating out of 5;
// ratings from older three-button kiosks arrive as 1, 3 and 5.
const LEVELS = [
  { key: "1", name: "1 - Very bad", color: "#DC2626" },
  { key: "2", name: "2 - Bad", color: "#F97316" },
  { key: "3", name: "3 - Okay", color: "#EAB308" },
  { key: "4", name: "4 - Good", color: "#84CC16" },
  { key: "5", name: "5 - Excellent", color: "#16A34A" },
];

export default LEVELS;
